import { render, staticRenderFns } from "./Tda.vue?vue&type=template&id=57734827&"
import script from "./Tda.vue?vue&type=script&lang=js&"
export * from "./Tda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports